class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.closeTimeout = null;
    this.onSummaryMouseEnter = this.onSummaryMouseEnter.bind(this);
    this.onSummaryMouseLeave = this.onSummaryMouseLeave.bind(this);
    this.onContentMouseEnter = this.onContentMouseEnter.bind(this);
    this.onContentMouseLeave = this.onContentMouseLeave.bind(this);
    this.onSummaryClick = this.onSummaryClick.bind(this);
    this.bindHoverEvents();
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  bindHoverEvents() {
    if (window.matchMedia('(max-width: 989px)').matches) return;
    this.summary?.addEventListener('mouseenter', this.onSummaryMouseEnter);
    this.summary?.addEventListener('mouseleave', this.onSummaryMouseLeave);
    this.content?.addEventListener('mouseenter', this.onContentMouseEnter);
    this.content?.addEventListener('mouseleave', this.onContentMouseLeave);
    this.summary?.addEventListener('click', this.onSummaryClick);
  }

  openMenu() {
    if (window.matchMedia('(max-width: 989px)').matches) return;
    window.clearTimeout(this.closeTimeout);

    this.closest('.header__inline-menu')
      ?.querySelectorAll('header-menu details[open]')
      .forEach((details) => {
        if (details === this.mainDetailsToggle) return;
        details.removeAttribute('open');
        details.querySelector('summary')?.setAttribute('aria-expanded', false);
      });

    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary')?.setAttribute('aria-expanded', true);
  }

  scheduleClose() {
    if (window.matchMedia('(max-width: 989px)').matches) return;
    window.clearTimeout(this.closeTimeout);
    this.closeTimeout = window.setTimeout(() => this.close(), 140);
  }

  onSummaryMouseEnter() {
    this.openMenu();
  }

  onSummaryMouseLeave() {
    this.scheduleClose();
  }

  onContentMouseEnter() {
    window.clearTimeout(this.closeTimeout);
    this.openMenu();
  }

  onContentMouseLeave() {
    this.scheduleClose();
  }

  onSummaryClick(event) {
    if (window.matchMedia('(max-width: 989px)').matches) return;

    const url = event.currentTarget.dataset.url;
    if (!url || url === '#') return;

    event.preventDefault();
    window.location.href = url;
  }
}

customElements.define('header-menu', HeaderMenu);
